import { BlogCard } from "../common";
import { STATIC_BLOGS } from "../../data/staticSiteContent";
import { Fade } from "react-awesome-reveal";

export default function BlogScreen() {
  const blogsList = STATIC_BLOGS;

  return (
    <div className=" bg-neutral-900 py-16 md:py-24 px-6">
      <div className="container mx-auto">
        {blogsList.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 py-5">
            <Fade direction="up" triggerOnce>
              {blogsList.map((item) => {
                return (
                  <BlogCard
                    key={item.id}
                    data={{ id: item.id, title: item.title, image: item.image }}
                  />
                );
              })}
            </Fade>
          </div>
        ) : (
          <p className="text-center">No blogs found!</p>
        )}
      </div>
    </div>
  );
}
